module.exports = __webpack_public_path__ + "static/media/grid-system.0a685119.md";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/legacy-app/grid-system.md
// module id = 386
// module chunks = 0